import type { ListBuilderList } from '../../../types';
import { createStandardTaskColumns } from '../columns';

/**
 * High Priority Tasks list configuration
 * Shows high priority pending tasks for the next 30 days
 */
export const highPriorityTasksList: ListBuilderList = {
	id: 'high-priority-tasks',
	cacheTTL: 300000,
	name: 'High Priority',
	type: 'default',
	active: true,
	sortOrder: 3,
	activeFilters: [
		'taskKeywords',
		'taskStatus',
		'taskAssignedUser',
		'taskClient',
		'taskLeadOrCustomer',
		'taskDueDateRange',
		'taskExternalCalendars',
	],
	columns: createStandardTaskColumns(),
	defaultSortId: 'column-due-date-column-asc',
	filterRules: {
		taskAssignedUser: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'tasks:view:any', negated: true }],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'tasks:view:any', negated: true }],
			},
		},
		taskPriority: {
			defaultValue: [{ id: '1', label: 'High' }],
		},
		taskStatus: {
			defaultValue: [{ id: 'pending', label: 'Pending' }],
		},
		taskDueDateRange: {
			defaultValue: [
				{
					id: 'next-30-days',
					label: 'Next 30 Days',
					data: {
						startDate: '{{DATE:0d}}',
						endDate: '{{DATE:30d}}',
					},
				},
			],
		},
	},
};
